module.exports = __webpack_public_path__ + "static/media/gift_2.3477f5a0.png";